import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana7Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
  <rect width="1221" height="921" fill="url(#pattern0_1466_34710)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M743.182 307.815H668.296L659.786 316.325L702.335 369.085L751.692 324.835C753.053 312.581 746.586 308.383 743.182 307.815Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M659.787 403.128C659.787 404.49 688.152 381.003 702.335 369.089L659.787 316.329L617.238 348.666C631.421 366.253 659.787 401.767 659.787 403.128Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M561.069 302.713L668.292 307.819L659.782 316.328L617.233 348.665L593.406 365.685L552.559 309.521L561.069 302.713Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M511.714 338.452L552.56 309.519L593.407 365.683L549.157 396.318L511.714 338.452Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M615.537 435.467L659.788 403.13L617.239 348.668L576.392 377.601L615.537 435.467Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M569.579 466.103L615.532 435.468L576.387 377.602L532.137 408.237L569.579 466.103Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M523.629 495.033L569.582 466.1L532.139 408.233L487.888 433.763L523.629 495.033Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M467.465 367.385L511.716 338.452L549.159 396.318L532.139 408.232L503.206 425.251L467.465 367.385Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M424.917 392.917L467.466 367.388L503.207 425.254L457.254 450.783L424.917 392.917Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M475.969 522.26L523.624 495.029L487.883 433.759L443.633 459.288L475.969 522.26Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M428.316 547.793L475.971 522.264L443.634 459.292L394.277 486.523L428.316 547.793Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M378.963 571.619L428.319 547.792L394.281 486.521L348.328 508.647L378.963 571.619Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M329.606 593.745L378.962 571.619L348.327 508.647L300.673 530.773L329.606 593.745Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M280.248 615.871L329.605 593.745L300.672 530.773L253.017 551.197L280.248 615.871Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M254.723 627.783L280.252 615.87L253.021 551.196L201.963 569.918L203.664 605.658C229.194 600.552 244.511 624.379 246.213 627.783C247.575 630.506 252.454 628.918 254.723 627.783Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M378.961 418.447L424.914 392.918L457.251 450.784L409.597 478.015L378.961 418.447Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M331.312 442.271L378.967 418.443L409.602 478.011L394.284 486.521L361.947 501.839L331.312 442.271Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M285.357 464.398L331.309 442.272L361.944 501.841L310.886 525.668L285.357 464.398Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M237.701 483.121L285.356 464.399L310.885 525.669L263.231 547.795L237.701 483.121Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M201.963 498.436L237.703 483.118L263.233 546.09L201.963 569.917V498.436Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1466_34710" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1466_34710" transform="matrix(0.0023345 0 0 0.00309493 -4.96413 -0.714246)"/>
    </pattern>
    <image id="image0_1466_34710"  width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};